import {
  DeploymentUnitStatus,
  ReleaseAndDeployments,
} from '@agilelab/plugin-wb-builder-common';

export const filterReleaseDeploymentsByEnvironment = (
  releases: ReleaseAndDeployments[],
  accessibleEnvironmentNames: string[],
): ReleaseAndDeployments[] => {
  const accessibleEnvironments = new Set(accessibleEnvironmentNames);

  return releases.map(release => ({
    ...release,
    deployments: (release.deployments ?? []).filter(deployment =>
      accessibleEnvironments.has(deployment.environment),
    ),
  }));
};

export const filterReleasesByDeploymentStatus = (
  releases: ReleaseAndDeployments[],
  deploymentStatuses?: DeploymentUnitStatus[],
): ReleaseAndDeployments[] => {
  if (!deploymentStatuses?.length) return releases;

  const selectedStatuses = new Set(deploymentStatuses);
  return releases.filter(release =>
    release.deployments.some(deployment =>
      selectedStatuses.has(deployment.status),
    ),
  );
};
